import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  DatePicker,
  Input,
  Menu,
  Row,
  Space,
  Table,
  Tooltip,
  Spin,
  message,
} from 'antd';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../../Images/FilterIcon.svg';
import { ReactComponent as PrintIcon } from '../../../Images/PrintIcon.svg';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchInwardPackingReport,
  fetchOutwardPackingDateWiseReport,
} from '../../../slices/report';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

function DispatchReport() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { user: currentUser } = useSelector(state => state.auth);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { OutwardDateWisedata = [] } = useSelector(state => state.report);

  const mappedData = (OutwardDateWisedata || []).map((item, idx) => ({
    sr_no: (page - 1) * pagesize + idx + 1,
    ...item,
    key: (page - 1) * pagesize + idx + 1,
  }));
  const [inputValue, setInputValue] = useState('');
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs(),
  ]);
  const handleSearch = e => {
    setSearch(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    const fetchData = () => {
      const params = {
        page,
        pagesize,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      };
      if (dateRange && dateRange[0] && dateRange[1]) {
        params.from_date = dateRange[0].format('YYYY-MM-DD');
        params.to_date = dateRange[1].format('YYYY-MM-DD');
      }
      try {
        dispatch(fetchOutwardPackingDateWiseReport(params));
      } catch (error) {
        console.error('API fetch error:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [dispatch, page, pagesize, search, orderBy, dateRange]);

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'name' && sortOrder === 'ascend') {
      sortingEnumKey = 'name';
    }
    if (sortField === 'name' && sortOrder === 'descend') {
      sortingEnumKey = '-name';
    }

    return sortingEnumKey;
  };

  const handleDateRangeChange = dates => {
    if (dates) {
      setDateRange(dates);
    }
  };
  const resetFilter = () => {
    setSearch('');
    setPage(1);
    setOrderBy('');
  };
  const csvHeaders = [
    { label: 'Sr No.', key: 'sr_no' },
    { label: 'Date', key: 'date' },
    { label: 'Shift A', key: 'shift_a' },
    { label: 'Shift B', key: 'shift_b' },
    { label: 'Total', key: 'total' },
  ];

  const csvData = mappedData;
  const handlePrintDownloadAll = async () => {
    setLoading(true);
    try {
      const params = {
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
        ...(dateRange && dateRange[0] && dateRange[1] && {
          from_date: dateRange[0].format('YYYY-MM-DD'),
          to_date: dateRange[1].format('YYYY-MM-DD'),
        }),
      };

      const response = await dispatch(fetchOutwardPackingDateWiseReport(params)).unwrap();
      const allData = response?.data || [];

      if (allData.length === 0) {
        message.error('No data available to print.');
        setLoading(false);
        return;
      }

      const pdf = new jsPDF('p', 'pt', 'a4');
      pdf.setFont('times');

      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
      const footerHeight = 40;
      const margin = { top: 80, left: 20, right: 20, bottom: footerHeight + 40 };

      // Title
      pdf.setFontSize(14);
      pdf.text('Dispatch Report', pageWidth / 2, 40, { align: 'center' });

      // Prepare PDF columns
      const pdfColumns = [
        { header: 'Sr No.', dataKey: 'sr_no', field: 'sr_no' },
        { header: 'Date', dataKey: 'date', field: 'date' },
        { header: 'Shift A', dataKey: 'shift_a', field: 'shift_a' },
        { header: 'Shift B', dataKey: 'shift_b', field: 'shift_b' },
        { header: 'Total', dataKey: 'total', field: 'total' },
      ];

      const pdffilteredColumns = pdfColumns.filter(column =>
        checkedList.includes(column.dataKey)
      );

      // Prepare PDF rows
      const pdfRows = allData.map((item, idx) => ({
        sr_no: idx + 1,
        date: item.date ? dayjs(item.date).format('DD-MM-YYYY') : 'N/A',
        shift_a: item.shift_a || '0',
        shift_b: item.shift_b || '0',
        total: item.total || '0',
      }));

      // Add table to PDF
      pdf.autoTable({
        columns: pdffilteredColumns,
        body: pdfRows,
        startY: margin.top,
        theme: 'grid',
        margin: margin,
        styles: {
          font: 'times',
          halign: 'center',
          overflow: 'linebreak',
          cellPadding: 3.5,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fillColor: false,
        },
        bodyStyles: {
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        alternateRowStyles: {
          fillColor: false,
        },
        columnStyles: {
          total: { halign: 'right' },
        },
        tableLineColor: [0, 0, 0],
        didDrawPage: (data) => {
          const pageNumber = pdf.internal.getNumberOfPages();
          const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;
          const currentDateTime = dayjs().format('DD/MM/YYYY hh:mm:ss A');

          const footerY = pdf.internal.pageSize.height - footerHeight / 2;

          // Clear footer area
          pdf.setFillColor(255, 255, 255);
          pdf.rect(margin.left, footerY - 15, pageWidth - margin.left - margin.right, footerHeight, 'F');

          pdf.setFontSize(10);
          pdf.text(currentDateTime, margin.left, footerY); // Left footer
          pdf.text(`Page ${currentPage}`, pageWidth - margin.right - 70, footerY); // Right footer
        },
      });

      pdf.autoPrint();
      const pdfBlob = pdf.output('blob');
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0px';
      iframe.style.bottom = '0px';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.border = 'none';
      iframe.src = URL.createObjectURL(pdfBlob);

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };
    } catch (error) {
      console.error('Print error:', error);
      message.error('Failed to generate print.');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setPageSize(pagination.pageSize);
    setOrderBy(orderBy);
  };

  const columns = [
    {
      title: 'Sr No.',
      dataIndex: 'sr_no',
      key: 'sr_no',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => {
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: 'Shift A',
      dataIndex: 'shift_a',
      key: 'shift_a',
    },
    {
      title: 'Shift B',
      dataIndex: 'shift_b',
      key: 'shift_b',
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
    },
  ];

  const [checkedList, setCheckedList] = useState([
    'sr_no',
    'date',
    'shift_a',
    'shift_b',
    'total',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="sr_no" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="date">Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="shift_a">Shift A</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="shift_b">Shift B</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="total">Total</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Dispatch Report</h2>
              <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Dispatch Report' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <RangePicker
                value={dateRange}
                format="DD-MM-YYYY"
                onChange={handleDateRangeChange}
                style={{ width: '300px', marginRight: '10px' }}
                presets={{
                  Today: [dayjs(), dayjs()],
                  'This Week': [dayjs().startOf('week'), dayjs()],
                  'This Month': [dayjs().startOf('month'), dayjs()],
                  'Last Month': [
                    dayjs().subtract(1, 'month').startOf('month'),
                    dayjs().subtract(1, 'month').endOf('month'),
                  ],
                }}
              />
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={search}
                  style={{ width: 190 }}
                  onChange={handleSearch}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                {currentUser.permissions.permissions.bundle_outward.includes(
                  'print_dispatch_report_copy',
                ) && (
                    <Tooltip title="Print">
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handlePrintDownloadAll}
                      >
                        <PrintIcon />
                      </Button>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.bundle_outward.includes(
                  'download_dispatch_report_excel_copy',
                ) && (
                    <Tooltip title="Export to CSV">
                      <CSVLink
                        data={csvData}
                        headers={csvHeaders}
                        filename={`dispatch_report_${dayjs().format('YYYY-MM-DD')}.csv`}
                        enclosingCharacter={'"'}
                        style={{ display: 'inline-block' }}
                      >
                        <Button type="primary" className="iconlink">
                          <FileExcelOutlined />
                        </Button>
                      </CSVLink>
                    </Tooltip>
                  )}
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>

      <div className="tablewrp">
        <div id="printable-table" style={{ width: '100%' }}>
          <Spin spinning={loading} >
            <Table
              rowKey="key"
              columns={filteredColumns}
              dataSource={mappedData}
              pagination={false}
              onChange={handleTableChange}
            />
          </Spin>
        </div>

        <Table
          rowKey="key"
          columns={filteredColumns}
          dataSource={mappedData}
          pagination={{
            current: page,
            pageSize: pagesize,
            total: OutwardDateWisedata.length,
            showTotal: total => `Total ${total} items`,
            onChange: handlePageChange,
          }}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
}

export default DispatchReport;